module.exports = __webpack_public_path__ + "img/88.17ea7d3e.jpg";